import { render, staticRenderFns } from "./CreateCoupon.vue?vue&type=template&id=3dd8dfaa&scoped=true&"
import script from "./CreateCoupon.vue?vue&type=script&lang=js&"
export * from "./CreateCoupon.vue?vue&type=script&lang=js&"
import style0 from "./CreateCoupon.vue?vue&type=style&index=0&id=3dd8dfaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd8dfaa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dd8dfaa')) {
      api.createRecord('3dd8dfaa', component.options)
    } else {
      api.reload('3dd8dfaa', component.options)
    }
    module.hot.accept("./CreateCoupon.vue?vue&type=template&id=3dd8dfaa&scoped=true&", function () {
      api.rerender('3dd8dfaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SAdmin/CreateCoupon.vue"
export default component.exports